/**
 * Règles d'adaptation de la barre du softphone — une seule ligne, jamais de
 * retour à la ligne (cf. handoff « Barre Softphone »).
 *
 * Trois paliers, dans cet ordre :
 *   1. `tight`    : on compresse les contrôles (libellés masqués, boutons
 *                   carrés 44 px) ;
 *   2. `iconOnly` : les onglets de fenêtres passent en icônes seules — sauf
 *                   l'onglet actif, qui garde son libellé tant qu'il reste de
 *                   la place (`labelActive`) ;
 *   3. `maxVisible` : ce qui ne tient toujours pas part dans « ⌃ N ».
 *
 * `vw` est la largeur disponible pour la barre (pas celle de l'écran : la
 * barre latérale en prend une part sur desktop), `n` le nombre de fenêtres
 * montées, `inCall` l'état d'appel (la pilule d'appel prend sa place).
 */
export function barLayout({ vw, n, inCall }) {
  const gaps = 56;
  const leftW = (t) => (t ? 76 : 250);
  const rightW = (t) => (t ? 104 : 300);
  const callW = (t) => (inCall ? (t ? 190 : 340) : 0);
  const room = (t) => Math.max(48, vw - gaps - leftW(t) - rightW(t) - callW(t));
  const need = n * 190;
  const xs = vw < 520;
  const narrow = vw < 760;
  const tight = xs || narrow || need > room(false);
  const avail = room(tight);
  const iconOnly = xs || n > 4 || need > avail;
  const per = iconOnly ? 48 : 190;
  const fits = Math.max(1, Math.floor(avail / per));
  const maxVisible = fits >= n ? n : Math.max(1, fits - 1);
  return {
    xs, narrow, tight, iconOnly, maxVisible,
    hiddenCount: Math.max(0, n - maxVisible),
    labelActive: iconOnly && !xs && avail > 260,
  };
}
